<template>
    <div>
        <h4>
            Activity Log
            <small>
                [<a href="#" @click.prevent="show = ! show">{{ show ? 'hide' : 'show' }}</a>]
            </small>
        </h4>

        <table class="table" v-if="show">
            <tbody>
            <tr v-for="comment in person.comments">
                <td>{{ comment.name }}</td>
                <td v-html="comment.description"></td>
                <td>{{ comment.created_at }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        props: ['person'],

        data() {
            return {
                lodash: window._,
                show: false,
            };
        },

        computed: {},
    }
</script>
